/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-confusing-void-expression */
/* eslint-disable @typescript-eslint/restrict-template-expressions */
import {
  Typography,
  useTheme,
  CircularProgress,
  DialogContent,
  Grid,
  TextField,
  InputAdornment,
  DialogActions,
  Tooltip,
} from '@mui/material';
import {
  type GridRowData,
  type GridColumns,
  type GridValidRowModel,
} from '@mui/x-data-grid';

import { AlertModal, CustomDataGrid, DialogBox } from 'components';
import { colorTheme } from 'theme';
import { useEffect, useState } from 'react';
import Buttons from 'components/elements/Buttons';
import { setSnackBarFailed, setSnackBarSuccess } from 'store/snackBar';
import { useDispatch, useSelector } from 'react-redux';
import { strings } from 'i18n/Strings';
import {
  getAllTodayOrderList,
  createAndPlaceOrder,
  confirmationIBorder,
} from 'service';
import { YesNoModal, ErrorModel } from 'components/shared';
import { CurrencyFormater } from 'components/helpers/commonFunctions/CurrencyFormater';
import {
  addBuyOrderValue,
  getContributtedAmount,
  getMasterFundsList,
} from 'service/OrderService';
import { handleNumberInputKeyDown } from 'utils/GeneralUtil';
import TodayOrderDetailed from './TodayOrderDetails';
import { useAppDispatch } from 'store';
import { setIsFundOrderProcessing } from 'store/fund';

export interface TodayOrderType {
  id?: number;
  fundId?: number;
  contractId?: number;
  fundName?: string;
  Symbol?: string;
  totalContribution?: string;
  planId?: number;
  transactionMethod?: string;
  planName?: string;
  units?: number;
  orderMethod: string;
}

export interface SearchUserDataType {
  email?: string;
  firstName?: string;
  lastName?: string;
  totalUnitsAllocated?: string;
  phone?: number;
  uniqueId?: string;
  fundDetails?: any[];
  fundData?: {
    fund1: string;
    fund2: string;
    fund3: string;
    fund4: string;
    fund5: string;
    fund6: string;
  };
}

export interface orderConfirmationStatus {
  orderId: string;
  confirmation: boolean;
}
export interface orderConfirmationMessage {
  id: string;
  isSuppressed: boolean;
  message: [];
  messageIds: [];
  isComplete: boolean;
}
export interface OrganizationInfo {
  email: string;
  firstName: string;
  lastName: string;
  uniqueId: string;
  phone: string;
  totalContribution: number;
  allocationAmount: number;
  totalUnitsAllocated: number;
}

interface FundDetail {
  contractId: number;
  fundId: string;
  name: string;
  symbol: string;
  description: string;
  shortDescription: string;
}

const TodayOrderDetails = (): JSX.Element => {
  const theme = useTheme();
  const dispatch = useAppDispatch();
  const colors = colorTheme(theme.palette.mode);
  const [planData, setPlanData] = useState<TodayOrderType[]>([]);
  const [openConfirmationDialog, setOpenConfirmationDialog] = useState(false);
  const [orderConfirmation, setOrderConfirmation] = useState([]);
  const [orderData, setOrderData] = useState<TodayOrderType>();
  const [placedFundId, setPlacedFundId] = useState(null);
  const [placedPlanId, setPlacedPlacedId] = useState(null);
  const [pageCount, setPageCount] = useState(null);
  const [isYesDisabled, setYesDisabled] = useState(false);
  const [totalAmount, setTotalAmount] = useState(0);
  const [ibError, setIbError] = useState<{
    information: string;
    open: boolean;
    title: string;
  }>({ information: '', open: false, title: '' });
  const pageInfo = useSelector((state) => state?.pagination?.todayOrders);
  const [openDialog, setOpenDialog] = useState(false);
  const [fundAmounts, setFundAmounts] = useState([]);
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const [allMasterFundDetails, setAllMasterFundDetails] = useState<
    FundDetail[]
  >([]);
  const [loader, setLoader] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [fundRow, setFundRow] = useState([]);
  const [placeOrderLoader, setPlaceOrderLoader] = useState(false);

  const handleClose = (): void => {
    setIsModalOpen(false);
  };

  const handleAmountChange = (
    contractId: number | string,
    value: number,
  ): void => {
    setFundAmounts((prevAmounts) => ({
      ...prevAmounts,
      [contractId]: value,
    }));
  };

  const disapatch = useDispatch();

  const getTotalAmount = async (): Promise<void> => {
    const amount = await getContributtedAmount();
    setTotalAmount(amount?.result?.totalContribution ?? 0);
  };

  const getAllPlanRequests = async (): Promise<void> => {
    try {
      const data = await getAllTodayOrderList(
        Number(pageInfo?.page) + 1,
        pageInfo?.pageSize,
      );
      const dataWithIds = data?.order?.map((item, index) => ({
        ...item,
        id: index,
      }));
      setPageCount(data?.count);
      setPlanData(dataWithIds);
    } catch (error) {
      console.log(error);
    }
  };

  const onClickePlaceOrder = async (orderData: TodayOrderType): void => {
    const orderDataWithMethod = {
      ...orderData,
      orderMethod: orderData.transactionMethod,
    };
    setOrderData(orderDataWithMethod);
    setPlacedFundId(orderData?.fundId);
    setPlacedPlacedId(orderData?.pensionPlanId);
    createAndPlaceOrder(orderDataWithMethod)
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      .then(async (res: any) => {
        setPlaceOrderLoader(false);
        dispatch(setIsFundOrderProcessing(false));
        if (res) {
          if (res.error) {
            setIbError({
              information: res.error || '',
              open: true,
              title: strings.displayText.idErrorHeader,
            });
            setPlacedFundId(null);
            setPlacedPlacedId(null);
            setOpenConfirmationDialog(false);
            setYesDisabled(false);
          } else if (res?.[0]?.order_id) {
            disapatch(
              setSnackBarSuccess({
                snackBarMessage: strings.displayText.orderPlacedText,
              }),
            );
            void getTotalAmount();
            void getAllPlanRequests();
          } else {
            setOrderConfirmation(res);
            setOpenConfirmationDialog(true);
          }
        }
        setPlacedFundId(null);
        setPlacedPlacedId(null);
      })
      .catch((err) => {
        setPlaceOrderLoader(false);
        dispatch(setIsFundOrderProcessing(false));
        setIbError({
          information: err?.response?.data?.message || '',
          open: true,
          title: strings.displayText.idErrorHeader,
        });
        setPlacedFundId(null);
        setPlacedPlacedId(null);
      });
  };
  const confirmIBOrder = async (): Promise<void> => {
    setYesDisabled(true);
    try {
      const confirmationVal = {
        orderId: orderConfirmation[0].id,
        confirmation: true,
        ...orderData,
      };
      void confirmationIBorder(confirmationVal)
        .then(async (data: any) => {
          if (data.error) {
            setIbError({
              information: data.error || '',
              open: true,
              title: strings.displayText.idErrorHeader,
            });
            setPlacedFundId(null);
            setPlacedPlacedId(null);
            setOpenConfirmationDialog(false);
            setYesDisabled(false);
          } else if (!data[0]?.isComplete) {
            setOrderConfirmation(data);
            setOpenConfirmationDialog(true);
          } else {
            setOpenConfirmationDialog(false);
            disapatch(
              setSnackBarSuccess({
                snackBarMessage: strings.displayText.orderPlacedText,
              }),
            );
            void getTotalAmount();
            void getAllPlanRequests();
          }
          setYesDisabled(false);
        })
        .catch(() => {
          disapatch(
            setSnackBarFailed({
              snackBarMessage: strings.displayText.errorMessage,
            }),
          );
          setYesDisabled(false);
        });
    } catch (error) {
      setIbError({
        information: error?.response?.data?.message || '',
        open: true,
        title: strings.displayText.idErrorHeader,
      });
      setPlacedFundId(null);
      setPlacedPlacedId(null);
      setOpenConfirmationDialog(false);
      setYesDisabled(false);
    }
    void getAllPlanRequests();
    void getTotalAmount();
  };

  const getAllMasterFunds = async (): Promise<void> => {
    try {
      const result = await getMasterFundsList();
      setAllMasterFundDetails(result?.data);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    void getTotalAmount();
  }, []);

  useEffect(() => {
    void getAllPlanRequests();
  }, [pageInfo?.page, pageInfo.pageSize]);

  useEffect(() => {
    void getAllMasterFunds();
  }, []);

  const handleDialogClose = (): void => {
    setOpenDialog(false);
    setFundAmounts([]);
  };

  const handleBuyorderClick = (): void => {
    setOpenDialog(true);
  };

  const handleConfirmOrder = (): void => {
    setOpenConfirmDialog(true);
  };

  const handlePlaceOrderConfirmed = (): void => {
    setLoader(true);

    const ordersPayload = allMasterFundDetails
      .filter((fund) => {
        const amount = fundAmounts[fund.contractId];
        return amount && parseFloat(amount) > 0;
      })
      .map((fund) => ({
        splitAmount: fundAmounts[fund.contractId],
        fundId: fund.fundId,
      }));

    if (ordersPayload.length === 0) {
      console.log('No valid orders to place');
      setLoader(false);
      return;
    }
    setOpenConfirmDialog(false);
    addBuyOrderValue({ data: ordersPayload })
      .then(() => {
        disapatch(
          setSnackBarSuccess({
            snackBarMessage: strings.displayText.buyOrderAddedZpText,
          }),
        );
        setOpenConfirmDialog(false);
        setOpenDialog(false);
        setLoader(false);
        void getTotalAmount();
        void getAllPlanRequests();
      })
      .catch((error) => {
        console.error('Error adding buy order values', error);
        setLoader(false);
      });
  };

  const columns: GridColumns<GridValidRowModel> = [
    {
      field: 'fundName',
      flex: 2,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.fundName}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Tooltip title={row?.description} placement="top">
          <Typography
            variant="h5"
            color={colors.gray[100]}
            fontSize={14}
            sx={{
              whiteSpace: 'normal',
              wordBreak: 'break-word',
            }}
          >
            {row?.shortDescription}
          </Typography>
        </Tooltip>
      ),
    },
    {
      field: 'Symbol',
      flex: 0.75,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.symbol}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.Symbol}
        </Typography>
      ),
    },
    {
      field: 'contractId',
      flex: 0.75,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.contractId}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {row.contractId}
        </Typography>
      ),
    },
    {
      field: 'userContribution',
      flex: 0.7,
      align: 'right',
      headerAlign: 'center',
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.totalContribution}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          <a
            style={{
              color: 'blue',
              textDecoration: 'underline',
              cursor: 'pointer',
            }}
            onClick={() => {
              setFundRow(row);
              setIsModalOpen(true);
            }}
          >
            {CurrencyFormater(Number(row.totalContribution).toFixed(2))}
          </a>
        </Typography>
      ),
    },

    {
      field: 'placeAndPreviewOrder',
      flex: 1.1,
      renderHeader: () => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          {strings.displayText.placeAndPreviewOrder}
        </Typography>
      ),
      renderCell: ({ row }) => (
        <Typography variant="h5" color={colors.gray[100]} fontSize={14}>
          <Buttons
            sx={{
              cursor: placeOrderLoader ? 'not-allowed' : 'pointer',
              height: 40,
              bgcolor: colors.greenAccent[500],
              borderRadius: 2,
            }}
            onClick={() => {
              if (!placeOrderLoader) {
                dispatch(setIsFundOrderProcessing(true));
                setPlaceOrderLoader(true);
                onClickePlaceOrder(row);
              }
            }}
            endIcon={
              placedFundId === row?.fundId &&
              placedPlanId === row?.pensionPlanId ? (
                <CircularProgress size={15} />
              ) : null
            }
            disabled={
              placedFundId === row?.fundId &&
              placedPlanId === row?.pensionPlanId
            }
          >
            {placeOrderLoader && placedFundId === row?.fundId
              ? strings.displayText.placing
              : strings.displayText.placeOrder}
          </Buttons>
        </Typography>
      ),
    },
  ];

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'flex-end',
          marginBottom: '10px',
        }}
      >
        <Buttons
          onClick={handleBuyorderClick}
          variant="contained"
          color="primary"
        >
          {strings.displayText.buyZpUnits}
        </Buttons>
      </div>
      <h4 style={{ margin: 0, marginTop: 30 }}>
        {strings.displayText.totalContributionAmount} :{' '}
        {CurrencyFormater(Number(totalAmount).toFixed(2))}
      </h4>
      <CustomDataGrid
        columns={columns}
        rows={planData as GridRowData[]}
        getRowId={(row: GridRowData) => `${String(row.id)}`}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? 'even' : 'odd'
        }
        pageCount={pageCount}
        currentPage="todayOrders"
      />

      <DialogBox
        screenWidth="lg"
        open={openDialog}
        onClose={handleDialogClose}
        title={strings.displayText.buyZpUnits}
        fullWidth
      >
        <DialogContent>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            {allMasterFundDetails.map((fund) => (
              <Grid
                container
                key={fund.contractId}
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  gap: '10px',
                }}
              >
                <Grid item style={{ flex: 1 }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.fundId}
                    value={fund?.fundId}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item style={{ flex: 4 }}>
                  <Tooltip title={fund?.description} placement="top">
                    <TextField
                      margin="normal"
                      fullWidth
                      label={strings.displayText.fundName}
                      value={fund?.shortDescription}
                      InputProps={{ readOnly: true }}
                    />
                  </Tooltip>
                </Grid>
                <Grid item style={{ flex: 1.75 }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.symbol}
                    value={fund?.symbol}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item style={{ flex: 1.75 }}>
                  <TextField
                    margin="normal"
                    fullWidth
                    label={strings.displayText.contractId}
                    value={fund?.contractId}
                    InputProps={{ readOnly: true }}
                  />
                </Grid>
                <Grid item style={{ flex: 2 }}>
                  <TextField
                    name={strings.displayText.amountEuro}
                    type="number"
                    margin="normal"
                    fullWidth
                    label={strings.displayText.amountEuro}
                    value={fundAmounts[fund.contractId] || ''}
                    onChange={(e) =>
                      handleAmountChange(
                        fund.contractId,
                        Number(e.target.value),
                      )
                    }
                    inputProps={{ min: 0 }}
                    onKeyDown={handleNumberInputKeyDown}
                    onWheel={(e) =>
                      e.target instanceof HTMLElement && e.target.blur()
                    }
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">€</InputAdornment>
                      ),
                    }}
                  />
                </Grid>
              </Grid>
            ))}
          </div>
        </DialogContent>
        <DialogActions>
          <Buttons
            disabled={
              loader ||
              Object.values(fundAmounts).every(
                (amount) => !amount || parseFloat(amount) <= 0,
              )
            }
            onClick={handleConfirmOrder}
            color="primary"
          >
            {strings.displayText.addBuyOrder}
          </Buttons>
        </DialogActions>
      </DialogBox>

      <AlertModal
        open={openConfirmDialog}
        onClose={() => {
          setOpenConfirmDialog(!openConfirmDialog);
        }}
        title={strings.displayText.areYouConfirm}
        isButtonForConfirmation={true}
        handleConfirm={handlePlaceOrderConfirmed}
      />

      {orderConfirmation.length > 0 && !orderConfirmation[0].order_id ? (
        <YesNoModal
          open={openConfirmationDialog}
          onClose={() => {
            setOpenConfirmationDialog(false);
          }}
          isDisabled={isYesDisabled}
          title={`${orderConfirmation[0].message[0]} ${strings.displayText.orderConfirmAgain}`}
          handleConfirm={confirmIBOrder}
        ></YesNoModal>
      ) : null}

      {ibError.open && (
        <ErrorModel
          open={ibError.open}
          title={ibError.title}
          onClose={() => {
            setIbError({ information: '', open: false, title: '' });
          }}
          information={ibError.information}
        />
      )}

      {isModalOpen && (
        <DialogBox
          open={isModalOpen}
          title="Buy Order Detailed"
          onClose={handleClose}
          fullWidth
        >
          <TodayOrderDetailed fundRow={fundRow} />
        </DialogBox>
      )}
    </>
  );
};

export default TodayOrderDetails;
